(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    const selectors = document.querySelectorAll('[data-quantity-selector]');

    selectors.forEach(function(selector) {
      const input = selector.querySelector('.quantity-selector__input');
      const minusBtn = selector.querySelector('.quantity-selector__btn--minus');
      const plusBtn = selector.querySelector('.quantity-selector__btn--plus');
      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 99;

      function updateValue(delta) {
        let currentValue = parseInt(input.value) || min;
        currentValue += delta;
        currentValue = Math.min(Math.max(currentValue, min), max);
        input.value = currentValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minusBtn.addEventListener('click', function() {
        updateValue(-1);
      });

      plusBtn.addEventListener('click', function() {
        updateValue(1);
      });

      input.addEventListener('change', function() {
        let value = parseInt(input.value) || min;
        value = Math.min(Math.max(value, min), max);
        input.value = value;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
